export default __webpack_public_path__ + "assets/images/7a1b5d619d3048c6ba2d2e62b24da3cd.png";